
/**
 * "safely" check if the madkudu thing is a stong lead.. crazy shit, wtf?
 *
 * if an error is encountered, `false` will be assumed.
 *
 * @param {Function} fn
 */

export function isStrongLead (fn) {
  if (typeof window.analytics.ready !== 'function') {
    return fn(false)
  }

  window.analytics.ready(() => {
    const { madkudu } = window
    if (!madkudu) {
      return fn(false)
    }

    if (typeof madkudu.ready !== 'function') {
      return fn(false)
    }

    madkudu.ready(() => {
      if (typeof madkudu.user !== 'function') {
        return fn(false)
      }

      const user = madkudu.user()
      if (typeof user.predictions !== 'function') {
        return fn(false)
      }

      user.predictions((err, predictions) => {
        if (err) {
          return fn(false)
        }

        const options = [ 'good', 'very good' ]
        const isStrongLead = options.indexOf(predictions.mk_customer_fit) > -1
        fn(isStrongLead)
      })
    })
  })
}



// WEBPACK FOOTER //
// ./lib/lead-predictions/index.js